module.exports = __webpack_public_path__ + "static/media/core-return-remanned-starter-labeled.5bf682cd.png";